import { FaHospital, FaLaptop, FaRegStar, FaStar, FaUserAlt } from 'react-icons/all';
import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, Grid, Table, TableBody, TableContainer, TableRow, TextField } from '@material-ui/core';
import { SButtonContainer, SCheckbox, SDialogButton, SDialogTitle, SLegenda, SSubtitle, STitleContainer, STitleH3, STitleSpan, SUserInfoContainer, SUserNameLabel } from './common/BCommonComponents';
import AuthContext from './auth/AuthContext';
import { PrestazioneConfigDTO, PuntoServizioDTO, UserDTO } from './common/Dtos';
import axios from 'axios';
import { toast } from 'react-toastify';
import { PuntiServizioHeadCell, PuntiServizioTableHeader } from './puntiServizio/PuntiServizio';
import { HeadCell, Order, STableCell, STableHead, STableRow } from './common/ScrivaniaTable';
import Paper from '@material-ui/core/Paper';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useHistory } from 'react-router-dom';
import { CambioPasswordDialog } from './CambioPasswordDialog';

export function ImpostazioniOperatore() {
	const auth = React.useContext(AuthContext);
	const history = useHistory();
	const [puntiServizioList, setPuntiServizioList] = useState<PuntoServizioDTO[]>([]);
	const [prestazioniConfList, setPrestazioniConfList] = useState<PrestazioneConfigDTO[]>([]);
	const [codiceFilter, setCodiceFilter] = useState('');
	const [nomeFilter, setNomeFilter] = useState('');
	const [puntoSelected, setPuntoSelected] = useState<PuntoServizioDTO>({
		cooperativa: '',
		createdBy: '',
		createdDate: '',
		id: '',
		puntoServizioConfig: false,
		indirizzo: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		name: '',
		operatori: [],
		asl: '',
		telefono: '',
		email: '',
		codiceTemporaneo: '',
		codiceDefinitivo: '',
		action: '',
		cooperativaName: ''
	});
	const [operatore, setOperatore] = useState<UserDTO>({
		id: '',
		login: '',
		email: '',
		firstname: '',
		lastname: '',
		cooperativa: '',
		authorities: [],
		createdBy: '',
		createdDate: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		telefono: '',
		indirizzo: '',
		activated: true,
		cooperativaName: '',
		codiceFiscale: '',
		unificazioneAsl: ''
	});

	//cambio password
	const [open, setOpen] = useState<boolean>(false);

	//table prestazioni
	const [order, setOrder] = useState<Order>('asc');
	const [orderBy, setOrderBy] = useState<string>('name');
	const [prestazioniPreferiteList, setPrestazioniPreferiteList] = useState<PrestazioneConfigDTO[]>([]);

	const headCells: PuntiServizioHeadCell[] = [
		{id: 'name', numeric: false, disablePadding: false, label: 'NOME', sortable: false},
		{id: 'asl', numeric: false, disablePadding: true, label: 'ASL DI COMPETENZA', sortable: false},
		{id: 'indirizzo', numeric: false, disablePadding: true, label: 'INDIRIZZO', sortable: false},
		{id: 'operatori', numeric: false, disablePadding: true, label: 'N. OPERATORI ASSOCIATI', sortable: false},
		{id: 'action', numeric: false, disablePadding: true, label: ' ', sortable: false}
	];

	const prestHeadCell: HeadCell[] = [
		{id: 'checkbox', numeric: false, disablePadding: false, label: '', sortable: false},
		{id: 'tipo', numeric: false, disablePadding: false, label: '', sortable: true},
		{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE', sortable: false},
		{id: 'name', numeric: false, disablePadding: false, label: 'NOME', sortable: false},
		// {id: 'description', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: false}
	]

	useEffect(() => {
		getOperatore();
		getPuntiServizio();
	}, []);

	useEffect(() => {
	}, [puntiServizioList, puntoSelected, prestazioniConfList]);

	const getOperatore = () => {
		auth.state.axiosInstance?.get('/api/accounts/' + auth.state.id)
			.then(res => {
				setOperatore(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero dell\'Operatore!');
				console.log(error);
			});
	}

	const getPuntiServizio = () => {
		auth.state.axiosInstance?.get('/api/puntoServizio/punti_servizio_of_operatore/' + auth.state.id)
			.then(res => {
				setPuntiServizioList(res.data);
				if (res.data && res.data.length > 0) {
					setPuntoSelected(res.data[0]);
					getPrestazioniPunto(res.data[0].id);
				}
			}).catch(error => {
			toast.error('🛑 Errore durante il recupero delle Prestazioni!');
			console.log(error);
		});
	}

	const getPrestazioniPunto = (idPunto: string) => {
		axios.all([
			auth.state.axiosInstance?.get('/api/puntoServizio/prestazioni_paginate/' + idPunto, {
				params: {
					codicePrestazione: '',
					testo: ''
				}
			}),
			auth.state.axiosInstance?.get('/api/accounts/prestazioni_preferite/' + auth.state.id + '/' + idPunto)
		])
			.then(axios.spread((res1, res2) => {
				setPrestazioniConfList(res1?.data.content);
				setPrestazioniPreferiteList(res2?.data);
			})).catch(error => {
			toast.error('🛑 Errore durante il recupero dei Punti di Servizio e Prestazioni di Config!');
			console.log(error);
		});
	}

	const getPrestazioniPreferite = (idPunto: string) => {
		auth.state.axiosInstance?.get('/api/accounts/prestazioni_preferite/' + auth.state.id + '/' + idPunto)
			.then(res => {
				setPrestazioniPreferiteList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			});
	}

	const handleCambioPassword = () => {
		setOpen(true);
	}

	const handleDialogClose = (newPassword?: string) => {
		setOpen(false);
		if (newPassword) {
			const encodedPsw = btoa(newPassword);
			auth.state.axiosInstance?.post('/api/accounts/change-user-password', {id: auth.state.id, newPassword: encodedPsw})
				.then(res => {
					toast.success("Password Modificata Correttamente!");
					history.push('/logout');
				})
				.catch(error => {
					toast.error('🛑 Errore durante la modifica della password');
					console.log(error);
					setOpen(true);
				});
		}
	}

	const handleVisualizzaOpzioni = (row: PuntoServizioDTO) => {
		setPuntoSelected(row);
		setNomeFilter('');
		setCodiceFilter('');
		getPrestazioniPunto(row.id);
	}

	const handleCodiceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodiceFilter(event.target.value);
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNomeFilter(event.target.value);
	}

	const filteredPrestazioni = (): PrestazioneConfigDTO[] => {
		let filtered = [...prestazioniConfList];

		if (codiceFilter && codiceFilter !== '') {
			filtered = filtered.filter(p => p.codice.toLowerCase().includes(codiceFilter.trim().toLowerCase()));
		}

		if (nomeFilter && nomeFilter !== '') {
			filtered = filtered.filter(p => p.name.toLowerCase().includes(nomeFilter.trim().toLowerCase()));
		}

		return filtered
	}

	const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleCheckBoxClick = (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
		if (event.target.checked) {
			aggiungiPreferita(id);
		} else {
			rimuoviPreferita(id);
		}
	}

	const aggiungiPreferita = (idPrestazione: string) => {
		const selectedIndex = prestazioniPreferiteList.findIndex(p => p.id === idPrestazione);
		if (selectedIndex === -1) {
			if (prestazioniPreferiteList && prestazioniPreferiteList.length === 5) {
				toast.error('🛑 Attenzione! Non si possono inserire più di 5 preferenze!');
			} else {
				auth.state.axiosInstance?.put('/api/accounts/add_prestazione_preferita/' + operatore.id + "/" + idPrestazione + '/' + puntoSelected.id)
					.then(res => {
						getPrestazioniPreferite(puntoSelected.id);
					})
					.catch(error => {
						toast.error('🛑 Errore durante l\'operazione!');
						console.log(error);
					});
			}
		}
	}

	const rimuoviPreferita = (idPrestazione: string) => {
		auth.state.axiosInstance?.delete('/api/accounts/delete_prestazione_preferita/' + operatore.id + "/" + idPrestazione + '/' + puntoSelected.id)
			.then(res => {
				getPrestazioniPreferite(puntoSelected.id);
			})
			.catch(error => {
				toast.error('🛑 Errore durante l\'operazione!');
				console.log(error);
			});
	}

	const isSelected = (id: string) => prestazioniPreferiteList.findIndex(p => p.id === id) !== -1;

	return (
		<div>
			<SUserInfoContainer>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={6}>
						<FaUserAlt className="color-primary" size={35}/>
						<SUserNameLabel>{operatore.firstname + " " + operatore.lastname}</SUserNameLabel>
					</Grid>
					<Grid item xs={3}>
						<SSubtitle><b>Login:</b> {operatore.login}</SSubtitle>
					</Grid>
					<Grid item xs={3}>
						<SSubtitle><b>Email:</b> {operatore.email}</SSubtitle>
					</Grid>
				</Grid>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={6}/>
					<Grid item xs={3}>
						<SSubtitle><b>Cooperativa:</b> {operatore.cooperativaName}</SSubtitle>
					</Grid>
					<Grid item xs={3}>
						<SSubtitle><b>Indirizzo:</b> {operatore.indirizzo}</SSubtitle>
					</Grid>
				</Grid>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={6}/>
					<Grid item xs={3}>
						<SSubtitle><b>Telefono:</b> {operatore.telefono}</SSubtitle>
					</Grid>
				</Grid>
			</SUserInfoContainer>
			<SButtonContainer>
				<SDialogButton onClick={handleCambioPassword}>Modifica Password</SDialogButton>
			</SButtonContainer>
			<STitleContainer>
				<STitleH3>Punti di servizio associati</STitleH3>
			</STitleContainer>
			<Paper>
				<TableContainer className="max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
						stickyHeader
					>
						<PuntiServizioTableHeader
							numSelected={0}
							rowCount={0}
							headCells={headCells}
							addCheckbox={false}
							bgcolor="primary"
							sortable={false}
							disableAction={false}
						/>
						<TableBody>
							{puntiServizioList &&
								puntiServizioList
									.map((row, index) => {
										return (
											<STableRow
												hover
												role="checkbox"
												tabIndex={-1}
												key={row.id}
											>
												<STableCell padding="default">{row.name}</STableCell>
												<STableCell padding="none">{row.asl}</STableCell>
												<STableCell padding="none">{row.indirizzo}</STableCell>
												<STableCell padding="none">{row.operatori?.length}</STableCell>
												<STableCell padding="none" className="text-center">
													<SDialogButton className="w-75" onClick={() => handleVisualizzaOpzioni(row)}>Visualizza Opzioni</SDialogButton>
												</STableCell>
											</STableRow>
										);
									})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
			<STitleContainer className="mt-5">
				<STitleH3>Opzioni {puntoSelected.name}</STitleH3>
				<STitleSpan>(Max 5 Preferenze)</STitleSpan>
			</STitleContainer>
			<Grid container spacing={1} className="w-100">
				<Grid item xs={12} className="d-flex justify-content-end mb-3">
					<SLegenda className="color-primary">LEGENDA: </SLegenda>
					<FaLaptop className="color-secondary mx-1" size={20}/> Attivit&agrave; di BackOffice
					<FaHospital className="color-secondary mx-1" size={20}/> Attivit&agrave; di FrontOffice
				</Grid>
			</Grid>
			<Grid container spacing={0} className="mb-3 w-100">
				<Grid item xs={3} className="pr-2">
					<TextField
						className="w-100"
						id="codice"
						label="Cerca codice"
						variant="outlined"
						value={codiceFilter}
						onChange={handleCodiceChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={3} className="px-2">
					<TextField
						className="w-100"
						id="prestazione"
						label="Cerca prestazione"
						variant="outlined"
						value={nomeFilter}
						onChange={handleNomeChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
			</Grid>
			<Paper>
				<TableContainer className="max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
						stickyHeader
					>
						<PrestazioniTableHeader
							order={order}
							orderBy={orderBy}
							onRequestSort={handleRequestSort}
							headCells={prestHeadCell}
							bgcolor="primary"
							sortable={false}
							disableAction={false}
						/>
						<TableBody>
							{filteredPrestazioni().map((row, index) => {
								const labelId = `enhanced-table-checkbox-${index}`;
								const isItemSelected = isSelected(row.id);

								return (
									<STableRow
										hover
										tabIndex={-1}
										key={row.id}
									>
										<STableCell padding="checkbox">
											<SCheckbox
												icon={<FaRegStar/>}
												checkedIcon={<FaStar/>}
												checked={isItemSelected}
												inputProps={{'aria-labelledby': labelId}}
												onChange={(event) => handleCheckBoxClick(event, row.id)}
											/>
										</STableCell>
										<STableCell style={{width: '5%'}} component="th" id={row.id} padding="default" size="small" className="text-center">
											{
												row.type === 'BACKOFFICE' ? <FaLaptop className="color-secondary" size={30}/> : <FaHospital className="color-secondary" size={30}/>
											}
										</STableCell>
										<STableCell padding="default">{row.codice}</STableCell>
										<STableCell padding="default">{row.name}</STableCell>
										{/*<STableCell padding="default">{row.description}</STableCell>*/}
									</STableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
			<CambioPasswordDialog open={open} onClose={handleDialogClose} canClose={true} userId={auth.state.id}/>
		</div>
	)
}

interface PrestazioniTableHeaderProps {
	onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
	order: Order;
	orderBy: string;
	headCells: HeadCell[];
	bgcolor: string;
	sortable: boolean;
	disableAction: boolean;
}

function PrestazioniTableHeader(props: PrestazioniTableHeaderProps) {
	const {order, orderBy, onRequestSort, bgcolor, sortable} = props;
	const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
		if (onRequestSort) {
			onRequestSort(event, property);
		}
	};

	return (
		<TableHead>
			<TableRow>
				{props.headCells.map((headCell) => (
					<STableHead
						key={headCell.id}
						align={headCell.numeric ? 'right' : 'left'}
						padding={headCell.disablePadding ? 'none' : 'default'}
						sortDirection={orderBy === headCell.id ? order : false}
						bgcolor={bgcolor}
					>
						{(sortable && order && orderBy) ?
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={createSortHandler(headCell.id)}
							>
								{headCell.label}
							</TableSortLabel>
							:
							headCell.label
						}

					</STableHead>
				))}
			</TableRow>
		</TableHead>
	);
}
